var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .045h17.961V18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.502 4.653A6.941 6.941 0 0 1 15.8 8.802c1.113 2.514.492 5.535-1.4 7.49-1.92 1.986-4.902 2.57-7.457 1.572-2.523-.985-4.21-3.506-4.288-6.19a7.201 7.201 0 0 1-.002-.17c-.003-.42-.655-.42-.653 0a7.595 7.595 0 0 0 3.9 6.584c2.41 1.336 5.453 1.185 7.745-.328 2.283-1.506 3.563-4.21 3.327-6.927-.234-2.694-1.973-5.1-4.44-6.193A7.582 7.582 0 0 0 9.503 4c-.421-.002-.421.65 0 .653"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.33 9.018a8.43 8.43 0 0 1-3.368 6.705c-2.142 1.596-4.961 2.048-7.506 1.26-2.466-.764-4.471-2.725-5.344-5.146C.206 9.32.6 6.487 2.095 4.284 3.564 2.12 6.048.78 8.65.672c2.644-.11 5.183 1.082 6.848 3.123 1.196 1.464 1.824 3.341 1.833 5.223.002.407.633.407.631 0a9.067 9.067 0 0 0-3.195-6.868C12.72.42 9.99-.275 7.362.18c-2.56.445-4.824 2.078-6.14 4.303-1.36 2.296-1.59 5.172-.665 7.667.905 2.44 2.865 4.365 5.288 5.288 2.496.95 5.367.67 7.667-.664 2.742-1.59 4.434-4.6 4.449-7.757.002-.407-.63-.407-.631 0",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 10.694V7.306c0-.408-1-.408-1 0v3.388c0 .408 1 .408 1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.455 11c-.028.587-.882.587-.91 0-.028-.587.882-.585.91 0 .017.35.561.35.545 0a1.02 1.02 0 0 0-1-.999c-.561-.027-.974.477-.999.999-.027.561.477.974 1 .999.56.027.974-.477.999-.999.016-.35-.528-.35-.545 0M10 2.682V1.318c0-.424-1-.424-1 0v1.364c0 .424 1 .424 1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.32 1.33H7.683c.004 0 .002-.664-.007-.663.204-.023.425 0 .63 0h2.008c-.004 0-.001.665.008.664-.433.048-.437.716 0 .666.341-.038.624-.228.666-.583.023-.202.008-.41.008-.614 0-.472-.259-.8-.765-.8H7.742C7.204 0 7 .385 7 .853c0 .479-.008 1.144.676 1.144H10.321c.44 0 .44-.666 0-.666M13.75 3.858l1.183-1.403c.282-.335-.404-.645-.683-.313l-1.183 1.403c-.282.335.404.645.683.313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.85 3.217L13.48 2.07c-.352-.295-.679.421-.33.713l1.372 1.147c.352.295.679-.421.33-.713M5.933 3.545L4.75 2.142c-.28-.332-.965-.022-.683.313L5.25 3.858c.28.332.965.022.683-.313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.479 3.93L4.85 2.783c.349-.292.022-1.008-.33-.713L3.15 3.217c-.35.292-.024 1.008.329.713"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.3a5e8d8cea338db53a37805b15162312.svg";
export { ForwardRef as ReactComponent };